import http from "./httpService";

const API_PATH = '/api/jp/1.0.0';

export const getJobPlans = async ({serviceURL, accessToken, params}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/jobplans`, { headers, params });

    return data;
};

export const getJobPlanDetails = async ({id, serviceURL, accessToken}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/jobplans/${id}`, { headers });

    return data;
};

export const deleteJobPlan = async ({serviceURL, accessToken, id}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.delete(`${serviceURL}${API_PATH}/jobplans/${id}`, { headers });

    return data;
}


export const addJobPlanActivity = async ({serviceURL, accessToken, jpId, params}) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.post(`${serviceURL}${API_PATH}/jobplans/${jpId}/activities`, params, { headers });

    return data;
};

export const updateJobPlanActivity = async ({serviceURL, accessToken, id, jpId, params}) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/jobplans/${jpId}/activities/${id}`, params, { headers });

    return data;
};

export const deleteJobPlanActivity = async ({serviceURL, accessToken, id, jpId}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.delete(`${serviceURL}${API_PATH}/jobplans/${jpId}/activities/${id}`, { headers });

    return data;
}

export const getJobPlanActivityCategories = async ({serviceURL, accessToken}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/config/activities/categories`, { headers });

    return data;
};

export const getJobPlanActivityTypes = async ({serviceURL, accessToken}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/config/activities/types`, { headers });

    return data;
};

export const getJobPlanActivityLocations = async ({serviceURL, accessToken}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/config/activities/locations`, { headers });

    return data;
};

export const getJobPlanActivityObjectives = async ({serviceURL, accessToken, jpId}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const params = { 'jobplanId': jpId };
    const { data } = await http.get(`${serviceURL}${API_PATH}/config/activities/objectives`, { headers, params });

    return data;
};

const jpService = {
    getJobPlans,
    getJobPlanDetails,
    deleteJobPlan,
    addJobPlanActivity,
    updateJobPlanActivity,
    deleteJobPlanActivity,
    getJobPlanActivityCategories,
    getJobPlanActivityTypes,
    getJobPlanActivityLocations,
    getJobPlanActivityObjectives
};

export default jpService;
